import { SET_STEP, INCREMENT_STEP, DECREMENT_STEP } from "./onboarding.type";

const initialState = {
  currentStep: 0,
};

const onboardingReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_STEP:
      return {
        ...state,
        currentStep: Number.isFinite(action.payload)
          ? action.payload
          : state.currentStep,
      };
    case INCREMENT_STEP:
      return {
        ...state,
        currentStep: state.currentStep + 1,
      };
    case DECREMENT_STEP:
      return {
        ...state,
        currentStep: state.currentStep > 0 ? state.currentStep - 1 : 0,
      };
    default:
      return state;
  }
};

export default onboardingReducer;



